    <section *ngFor="let ab of about">
        <div class="header-title">
            <h1 i18n="About Title|Title for About Page@@TitleAbout">About me</h1>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 25 1440 200">
              <path fill="#ffffff" fill-opacity="1" d="M0,128L80,122.7C160,117,320,107,480,122.7C640,139,800,181,960,181.3C1120,181,1280,139,1360,117.3L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
            </svg>
          </div>
        <div class="fulltext" [innerHTML]="ab.fullText" wmAnimate="fadeInUp" aos></div>
        <div class="skills" id="skills" wmAnimate="fadeInRight" aos *ngIf="valor > 250">
            <div class="row">
                <div class="col-md-6">
                    <div class="col-md-12">
                        <h4 i18n="Product Graphs|Title for Product Graph Skills@@ProductSkills">Product Skills</h4>
                    </div>
                    <div class="col-md-12">
                        <canvas baseChart height="300"
                                [datasets]="barChartData1"
                                [labels]="barChartLabels1"
                                [options]="barChartOptions"
                                [legend]="barChartLegend"
                                [chartType]="barChartType"
                                [colors]="chartColors">
                        </canvas>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="col-md-12">
                        <h4 i18n="Development Graphs|Title for Development Graph Skills@@DevelopmentSkills">Web Skills</h4>
                    </div>
                    <div class="col-md-12">
                        <canvas baseChart height="300"
                                [datasets]="barChartData2"
                                [labels]="barChartLabels2"
                                [options]="barChartOptions"
                                [legend]="barChartLegend"
                                [chartType]="barChartType"
                                [colors]="chartColors">
                        </canvas>
                    </div>
                </div>
            </div>
            
        </div>
    </section>


